<template>
	<div>
		<compWrapper title="基础信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<compWrapper title="费用详情" theme="primary">
			<compTablelist class="margin-layout" :columns="columns" v-bind="getCostTableProps"></compTablelist>
		</compWrapper>
		<compLog wrapper :data="logList" :columns="columnsLog">
			<vButtonGroup slot="footer">
				<vButton v-if="detailtype!='customer' && formData.billStatus == 0" theme="primary" @click="confirm">确认账单</vButton>
				<vButton @click="cancel">返回</vButton>
			</vButtonGroup>
		</compLog>
		<compModal
			v-model="operate.show"
			v-bind="operate"
			@on-close="operate.show=false"
			@on-confirm="operate={}"
		></compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpBillManage, HttpBillManageDetail, HttpBillManageLog, HttpConfirmBill } from '@/service/costbilling';
import mixin from '../../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
		compTablelist: () => import("@components/templates/tablelist"),
	},
	data() {
		return {
			loading: false,
			formData: {},
			id: this.$route.query.id,
			detailtype: this.$route.query.detailtype,
			logList: [],
			// billList: [],
			operate: {
				show: false,
			}
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		// ...mapGetters('dictionary', ['getSysorgList']),
		//费用详情table
		getCostTableProps() {
			return {
				initFormData:{
					'search[EQ_billId]': this.id,
				},
				startUp:true,
				ajaxRequest: HttpBillManageDetail,
			};
		},
		getBase() {
			return [
				{
					label: '账单编号',
					key: 'billNo',
				},
				{
					label: '状态',
					key: 'billStatus',
					options: [
						{ value: 0, label: '已创建' },
						{ value: 1, label: '已确认' },
					],
				},
				{
					label: '组织',
					key: 'organizationName',
				},
				// {
				// 	label: '仓库',
				// 	key: 'warehouseCode',
				// },
				{
					label: '总费用',
					// key: 'totalCost',
					valueText: this.formData.totalCost + ' ' + this.formData.currency
				},
				{
					label: '月份',
					key: 'billingDate',
				},
				{
					label: '项目',
					key: 'lineName',
				}
				
			]
		},
		columns() {
			return [
				{
					title: "NO",
					type: 'index',
					width:60
				},
				{
					title: "操作",
					render: (h, { row }) => {
						return <vButton theme="primary" size='small' onClick={this.goDetails.bind(this, row)}>查看明细</vButton>
					}
				},
				{
					title: "费用类型",
					render: (h, { row }) => {
						const type = row.costType;
						const { label = '' } = this.getCostType.find(function (item) {
							return item.value == type
						}) || {};
						return label
					}
				},
				{
					title: "费用",
					key: 'totalCost',
					render(h, { row }) {
						return <div>{row.totalCost} {row.currency}</div>
					}
				},
			]
		},
		columnsLog() {
			return [
				{
					title: "操作类型",
					render(h, { row }) {
						switch (row.operateType) {
							case 0: return '创建'; break;
							case 1: return '确认'; break;
							case 2: return '忽略异常'; break;
						}
					},
				},
				{
					title: "操作人",
					key: 'createdName',
				},
				{
					title: "备注",
					key: 'remark',
				},
				{
					title: "操作时间",
					key: 'updatedAt',
				},
			]
		}
	},
	methods: {
		//跳转账单明细
		goDetails(data) {
			this.$router.push({
				name: this.$route.name + 's',
				query: {
					id: data.id,
					billNo: data.billNo,
					type: data.costType,
					parentId: this.id
				}
			})
		},
		cancel() {
			this.$router.push({
				name: this.$route.name.slice(0, -6)
			})
		},
		//  确认账单
		confirm() {
			let _this = this
			this.operate = {
				show: true,
				title: '确认账单',
				alert: "success",
				params: { id: this.id },
				ajaxRequest: HttpConfirmBill,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
						required: false,
					}
				],
				callback(res){
					_this.getDetail()
				}
			}
		},
		//操作历史
		getLogs() {
			this.loading = true
			HttpBillManageLog({
				'search[EQ_orderNo]': this.formData.billNo,
				page: 1,
				rows: 1000,
			}).then(res => {
				this.loading = false
				this.logList = res.data.content
			}).catch(err=>{
				this.loading = false
			})
		},
		//费用详情
		// getCostDetail() {
		// 	this.loading = true
		// 	HttpBillManageDetail({
		// 		'search[EQ_billId]': this.id,
		// 		page: 1,
		// 		rows: 1000,
		// 	}).then(res => {
		// 		this.loading = false
		// 		this.billList = res.data.content;
		// 	}, err => {
		// 		this.loading = false
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//账单详情
		getDetail() {
			// this.loading = true
			// this.getCostDetail();
			HttpBillManage({ id: this.id }).then(res => {
				this.formData = res.data;
				this.loading = false;
				this.getLogs();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
	}
};
</script>
